import { TFunction } from 'i18next';

import { CustomerFlagDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export const flagOptions = (t: TFunction): SelectSearchOptionModel<CustomerFlagDto>[] =>
  Object.keys(CustomerFlagDto).map(it => {
    const item = CustomerFlagDto[it as keyof typeof CustomerFlagDto];
    return {
      label: t(`flagOptions.${item}`),
      value: item,
    };
  });
